(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-content"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.customElements.get('article-content')) return;

    const MIN_DIVIDER_UNDERSCORES = 20;

    const BLOCK_ELEMENTS = 'p, div, hr, img, picture, iframe, video, figure, blockquote, ul, ol, table, h1, h2, h3, h4, h5, h6, .article-image-grid';

    const BREAKING_ELEMENTS = 'iframe, video, audio, object, embed, table, hr, h1, h2, h3, h4, h5, h6, blockquote, ul, ol';

    const hasMeaningfulText = (text) => text.replace(/[\s\u200b]/g, '') !== '';

    const MEDIA = 'img, video, iframe, svg, picture, audio, embed, object, canvas, hr, .article-image-grid';

    const isEmpty = (element) =>
      !element.matches(MEDIA) && !element.querySelector(MEDIA) && !hasMeaningfulText(element.textContent);

    class ArticleContent extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-image-grid-ready')) return;
        this.setAttribute('data-image-grid-ready', '');

        this.removeBrokenImages();
        this.replaceUnderscoreDividers();
        this.collectRuns().forEach((run) => this.buildGrid(run));
        this.tidy();
      }

      /*
        The legacy content contains bare <img> tags without a source. They render as empty
        cells in the grid, so drop them (and any wrapper left empty) before grouping.
      */
      removeBrokenImages() {
        this.querySelectorAll('img').forEach((image) => {
          const hasSource = ['src', 'srcset', 'data-src', 'data-srcset'].some((name) => (image.getAttribute(name) || '').trim() !== '');
          if (hasSource || image.closest('picture')?.querySelector('source[srcset]')) return;

          const parent = image.parentElement;
          image.remove();
          this.removeEmptyAncestors(parent);
        });
      }

      /*
        The legacy content draws dividers as long runs of underscores, split over several
        text nodes and sometimes glued to the next text ("_____Photography: ..."). Replace
        each run with a real <hr>.
      */
      replaceUnderscoreDividers() {
        const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
        const textNodes = [];
        while (walker.nextNode()) textNodes.push(walker.currentNode);

        let run = [];
        let count = 0;
        const flush = () => {
          if (count >= MIN_DIVIDER_UNDERSCORES) this.insertDivider(run);
          run = [];
          count = 0;
        };

        textNodes.forEach((node) => {
          const text = node.textContent;

          if (/^[\s_]*$/.test(text)) {
            if (!text.includes('_')) return;
            run.push(node);
            count += text.split('_').length - 1;
            return;
          }

          const leading = text.match(/^[\s\u200b]*(_+)/);
          if (leading && run.length > 0) {
            count += leading[1].length;
            if (count >= MIN_DIVIDER_UNDERSCORES) node.textContent = text.slice(leading[0].length);
          }

          flush();
        });

        flush();
      }

      insertDivider(nodes) {
        const divider = document.createElement('hr');
        divider.className = 'article-divider';
        nodes[0].before(divider);

        const parents = new Set(nodes.map((node) => node.parentElement));
        nodes.forEach((node) => node.remove());
        parents.forEach((parent) => this.removeEmptyAncestors(parent));
        this.hoist(divider);
      }

      /* Normalizes spacing from the legacy content: drops line breaks around grids and empty spacer paragraphs. */
      tidy() {
        this.querySelectorAll('.article-image-grid').forEach((grid) => {
          this.trimSiblings(grid, 'nextSibling');
          this.trimSiblings(grid, 'previousSibling');
        });

        this.querySelectorAll('br').forEach((br) => {
          if (this.isEdgeBreak(br, 'previousSibling') || this.isEdgeBreak(br, 'nextSibling')) br.remove();
        });

        /* Elements with an id are kept: third-party embeds often fill an empty placeholder later. */
        Array.from(this.querySelectorAll('p:not([id]), div:not([id]), span:not([id])'))
          .reverse()
          .forEach((element) => {
            if (element.isConnected && isEmpty(element)) element.remove();
          });

        /* A divider with nothing after it would only separate the post from the share buttons. */
        this.querySelectorAll('.article-divider').forEach((divider) => {
          const rest = document.createRange();
          rest.setStartAfter(divider);
          rest.setEndAfter(this.lastChild);
          const after = rest.cloneContents();

          if (!hasMeaningfulText(after.textContent) && !after.querySelector(MEDIA)) {
            const parent = divider.parentElement;
            divider.remove();
            this.removeEmptyAncestors(parent);
          }
        });
      }

      /*
        True when a <br> has no inline content on one side within its block: it sits at the start or
        end of a paragraph, or next to a block (grid, divider, embed). Breaks between two pieces of
        text are intentional line breaks and are kept.
      */
      isEdgeBreak(br, direction) {
        let node = br;

        while (node && node !== this) {
          let sibling = node[direction];

          while (sibling) {
            if (sibling.nodeType === Node.TEXT_NODE) {
              if (hasMeaningfulText(sibling.textContent)) return false;
            } else if (sibling.nodeType === Node.ELEMENT_NODE) {
              if (sibling.matches(BLOCK_ELEMENTS)) return true;
              if (sibling.tagName !== 'BR' && !isEmpty(sibling)) return false;
            }
            sibling = sibling[direction];
          }

          node = node.parentElement;
          if (!node || node.matches(BLOCK_ELEMENTS)) return true;
        }

        return true;
      }

      trimSiblings(grid, direction) {
        let node = grid[direction];

        while (node) {
          const next = node[direction];
          const removable =
            node.nodeType === Node.TEXT_NODE ? !hasMeaningfulText(node.textContent) : node.nodeType === Node.ELEMENT_NODE && isEmpty(node);

          if (!removable) break;

          node.remove();
          node = next;
        }
      }

      /* Groups consecutive images (in document order) into runs, broken by text, other media or layout markers. */
      collectRuns() {
        const runs = [];
        let run = [];
        const flush = () => {
          if (run.length > 1) runs.push(run);
          run = [];
        };

        const walker = document.createTreeWalker(this, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
        let node;
        /* `[image]` marks a single full-width image: the image right after it never joins a grid. */
        let soloNext = false;

        while ((node = walker.nextNode())) {
          if (node.nodeType === Node.TEXT_NODE) {
            if (hasMeaningfulText(node.textContent)) flush();
          } else if (node.matches('.article-hook')) {
            flush();
            soloNext = node.dataset.layout === 'image';
          } else if (node.tagName === 'IMG') {
            if (soloNext) {
              soloNext = false;
              continue;
            }
            run.push(this.getMovableItem(node));
          } else if (node.matches(BREAKING_ELEMENTS)) {
            flush();
          }
        }

        flush();
        return runs;
      }

      /* Keeps a link around an image when the link wraps nothing but that image. */
      getMovableItem(image) {
        const link = image.parentElement;
        if (link && link.tagName === 'A' && link !== this && link.querySelectorAll('img').length === 1 && !hasMeaningfulText(link.textContent)) {
          return link;
        }
        return image;
      }

      buildGrid(items) {
        items = items.filter((item) => this.contains(item));
        if (items.length < 2) return;

        const grid = document.createElement('div');
        grid.className = 'article-image-grid';
        items[0].before(grid);

        const formerParents = new Set();
        items.forEach((item) => {
          if (item.parentElement !== grid) formerParents.add(item.parentElement);
          grid.append(item);
        });

        formerParents.forEach((parent) => this.removeEmptyAncestors(parent));
        this.hoist(grid);
      }

      removeEmptyAncestors(element) {
        while (element && element !== this && element.isConnected && isEmpty(element)) {
          const parent = element.parentElement;
          element.remove();
          element = parent;
        }
      }

      /* Moves an element out of wrappers (p, span, div) that contain nothing else, so it is not nested inside a paragraph. */
      hoist(element) {
        let parent = element.parentElement;

        while (parent && parent !== this && parent.parentNode) {
          const onlyElement = Array.from(parent.childNodes).every((child) => {
            if (child === element) return true;
            if (child.nodeType === Node.TEXT_NODE) return !hasMeaningfulText(child.textContent);
            if (child.nodeType === Node.ELEMENT_NODE) return isEmpty(child);
            return true;
          });

          if (!onlyElement) break;

          parent.replaceWith(element);
          parent = element.parentElement;
        }
      }
    }

    window.customElements.define('article-content', ArticleContent);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klaviyo-back-in-stock"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('.klaviyo-bis__trigger');

    if (openButton) {
      openButton.closest('[data-bis]')?.querySelector('dialog')?.showModal();
      return;
    }

    if (event.target.closest('[data-bis-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }

    // A click on the backdrop targets the dialog element itself
    if (event.target.matches('.klaviyo-bis__dialog')) {
      event.target.close();
    }
  });

  // The product re-render doesn't replace this block, so follow the selected variant ourselves
  document.addEventListener('variant:change', (event) => {
    const { variant } = event.detail || {};

    // detail.formId is unusable here: the form has an <input name="id">, which shadows form.id, so use the attribute
    const formId = event.target.getAttribute?.('id');

    if (!variant || !formId) {
      return;
    }

    document.querySelectorAll('[data-bis]').forEach((block) => {
      if (block.dataset.formId !== formId) {
        return;
      }

      const form = block.querySelector('[data-bis-form]');
      const soldOut = variant.available === false;

      block.hidden = !soldOut;

      if (soldOut && form) {
        form.dataset.variantId = variant.id;
        form.querySelector('.klaviyo-bis__fields').hidden = false;
        form.querySelector('.klaviyo-bis__success').hidden = true;
        form.querySelector('.klaviyo-bis__error').hidden = true;
        block.querySelector('dialog')?.close();
      }
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('[data-bis-form]');

    if (!form) {
      return;
    }

    event.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const submitButton = form.querySelector('button[type="submit"]');
    const successMessage = form.querySelector('.klaviyo-bis__success');
    const errorMessage = form.querySelector('.klaviyo-bis__error');

    errorMessage.hidden = true;
    submitButton.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${form.dataset.companyId}`, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          revision: '2024-02-15'
        },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: form.elements.email.value.trim() }
                }
              }
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${form.dataset.variantId}`
                }
              }
            }
          }
        })
      });

      if (!response.ok) {
        throw new Error(`Klaviyo responded with ${response.status}`);
      }

      form.querySelector('.klaviyo-bis__fields').hidden = true;
      successMessage.hidden = false;
    } catch (error) {
      errorMessage.hidden = false;
    } finally {
      submitButton.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
